export class CreateInsideSurveyDTO {
  insideSurveyId: string;
  buildingId: string;
  buildingGroupId: string;
  insideEngineerId: string;

  constructor(dto: {
    insideSurveyId?: string;
    buildingId?: string;
    buildingGroupId?: string;
    insideEngineerId?: string;
  }) {
    this.insideSurveyId = dto.insideSurveyId;
    this.buildingId = dto.buildingId;
    this.buildingGroupId = dto.buildingGroupId;
    this.insideEngineerId = dto.insideEngineerId;
  }
}
